import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../api/api";
import { b2bcredit } from "../../api/urls";
import { setCreditData } from "../../Redux/B2b";
import { useState } from "react";

import { b2bLedger } from "../../api/urls";
import { useNavigate } from "react-router-dom";
import { ArrowDownRight, ArrowUpLeft } from "lucide-react";

const B2Bcredit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const credit = useSelector((state) => state.credit);
  const [ledgerData, setLedgerData] = useState([]);
  useEffect(() => {
    const fetchCredit = async () => {
      try {
        const response = await api.get(b2bcredit);

        dispatch(setCreditData(response.data));
      } catch (error) {
        console.error("Failed to fetch B2B credit:", error);
      }
    };

    fetchCredit();
  }, [dispatch]);
  useEffect(() => {
    const fetchLedger = async () => {
      try {
        const response = await api.get(b2bLedger);

        setLedgerData(response.data || []);
      } catch (err) {
        console.error("Ledger fetch failed", err);
      }
    };

    fetchLedger();
  }, []);

  const formatDate = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <div style={{ padding: "16px", fontFamily: "sans-serif" }}>
      <h1
        style={{
          fontWeight: "500",
          fontSize: "25px",
          marginTop: "20px",
          marginBottom: "10px",
          padding: "0px 29px",
        }}
      >
        B2B Credits
      </h1>

      {/* Credit Summary */}
      <div
        style={{
          padding: "24px 32px",
          // padding: "12px",
          borderRadius: "15px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
            border: "1px solid #e5e7eb",
          }}
        >
          <span>Utilized Credit</span>
          {/* <span>₹ {credit?.amount || 0}/-</span> */}
          <span>₹ {Number(credit?.utilized) || 0}/-</span>
        </div>
        <div
          style={{
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
            border: "1px solid #e5e7eb",
          }}
        >
          <span>Available Credit</span>
          <span>₹ {Number(credit?.data) || 0}/-</span>
        </div>
        <div
          style={{
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #e5e7eb",
          }}
        >
          <span>Credit Limit</span>

          <span>₹ {Number(credit?.limit) || 0}/-</span>
        </div>
      </div>

      {ledgerData.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 35px",
            fontWeight: "400",
          }}
        >
          <h4
            style={{
              fontWeight: "400",
              fontSize: "22px",
              marginBottom: "20px",
            }}
          >
            Your Transactions
          </h4>
        </div>
      )}
      {ledgerData.length > 0 &&
        ledgerData?.map((txn, index) => {
          let icon;
          // if (txn.tagsused === "BILL PAID") icon = <ArrowDownLeft size={16} color="#16a34a" />;
          if (txn.tagsused === "BILL PAID")
            icon = <ArrowDownRight size={16} color="#16a34a" />;
          // else if (txn.tagsused === "DATE EXTENDED") icon = <CalendarClock size={16} color="#2563eb" />;
          else icon = <ArrowUpLeft size={16} color="#dc2626" />;

          const isCredit =
            txn.transaction_type === "CR" || txn.tagsused === "BILL PAID";

          const isPaid = txn.is_paid === "PAID";

          return (
            <div
              key={index}
              onClick={() => navigate("/creditDetails", { state: txn })}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",

                borderRadius: "8px",
                padding: "12px 16px",
                marginBottom: "12px",
                backgroundColor: "#ffffff",
                cursor: "pointer",
              }}
            >
              {/* Left: Icon + Info */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                  padding: "0 21px",
                }}
              >
                <div>{icon}</div>
                <div>
                  <div
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    {txn.tagsused}
                  </div>
                  <div style={{ fontSize: "11px", color: "#666" }}>
                    {txn.tagsused === "DATE EXTENDED"
                      ? `Ext. from ${formatDate(
                          txn.created_at
                        )} to ${formatDate(txn.duedate)}`
                      : `${txn.tagsused} on ${
                          formatDate(txn.created_at).split(",")[0]
                        }`}
                  </div>
                </div>
              </div>

              <div style={{ textAlign: "right", padding: "0 24px" }}>
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",

                    color: txn.tagsused === "BILL PAID" ? "#16a34a" : "#dc2626",
                  }}
                >
                  {isCredit ? "+" : "-"} ₹{Number(txn.amount).toFixed(2)}/-
                </div>
                <div
                  style={{
                    fontSize: "11px",
                    color: isPaid ? "#16a34a" : "#dc2626",

                    fontWeight: 500,
                  }}
                >
                  {isPaid ? "Paid" : "Unpaid"}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default B2Bcredit;
